import { useTranslation } from 'next-i18next';
import { useMediaMatch } from '../../../hooks';
import { CheckCircle } from '../../../icons';
import { TypographyStyles, media } from '../../../stylings';
import { getLocalizedValue } from '../../../utils';
import {
  SuccessContentContainer,
  SuccessIcon,
  SuccessMessageContainer,
  SuccessMessageText,
  TermsAndPolicy,
} from './SuccessMessage.style';

export function SuccessMessage({ richText }: { richText?: string }) {
  const isDesktop = useMediaMatch(media.greaterThan('lg'));
  const { t } = useTranslation('lib-global-common');

  return (
    <SuccessMessageContainer role="status">
      <SuccessContentContainer>
        <SuccessIcon data-testid="newsletterSuccessIcon">
          <CheckCircle />
        </SuccessIcon>
        {isDesktop ? (
          <TermsAndPolicy text={getLocalizedValue(richText)} fontSize={TypographyStyles.Body.Tiny.Regular} />
        ) : null}
      </SuccessContentContainer>
      <SuccessMessageText data-testid="newsletterSuccessMessage">
        {t('footer.newsletter.success.title')}
      </SuccessMessageText>
      {!isDesktop ? (
        <TermsAndPolicy text={getLocalizedValue(richText)} fontSize={TypographyStyles.Body.Tiny.Regular} />
      ) : null}
    </SuccessMessageContainer>
  );
}
